<template>
  <transition name="slide-fade">
    <div v-if="visible" class="toast feedback-alert" @click="onClick">
      <div class=" icon-wrap">
        <i class="glyphicon icon-feedback"></i>
      </div>
      <div class="text-wrap">
        <div class="title">
          {{ toast.title }}
        </div>
        <div class="content">
          {{ toast.content }}
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['toast'],
  data () {
    return {
      visible: false
    }
  },
  mounted () {
    this.visible = true // 從 false 轉為 true 才會觸發動畫
  },
  methods: {
    onClick () {
      this.visible = false
      location.href = this.toast.link
    }
  }
}
</script>

<style lang="scss" scoped>
.toast {
  background: rgba(50, 50, 50, 0.9);
  color: white;
  padding: 10px 20px;
  margin-top: 10px;
  border-radius: 6px;
  word-break: break-word;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    box-shadow: 2px 4px 5px -1px rgba(0, 0, 0, 0.6);

}

/* transition */
.slide-fade-enter-active {
  animation: slideIn 0.5s forwards;
}
.slide-fade-leave-active {
  animation: slideOut 0.5s forwards;
}
@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes slideOut {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
}

.feedback-alert {
  width: 100%;
  box-sizing: border-box;
  padding: 15px 40px;
  border-radius: 4px;
  display: flex;
  gap: 15px;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.8);
  transition: background-color 0.2s;
  color: #fff;
  cursor: pointer;

  &:hover {
    background-color: rgba(50, 50, 50, 0.9);
  }

  .icon-wrap {
    display: flex;
    align-items: center;

    i {
      font-size: 60px;
      color: $mainColor;
    }
  }

  .text-wrap {
    padding: 12px 0px;
    .title {
      font-size: map-get($fontSize, large);
      max-width: 300px;
      font-weight: bold;
      margin-bottom: 4px;
    }

    .content {
      max-width: 360px;
      font-size: map-get($fontSize, medium);
      color: $lightFontColor;
    }
  }
}

</style>
